/* eslint-disable */
import request from './helpers'

export function listTopicConfigItems() {
    return request({
        url: '/api/v1/command/list/topic/config_items',
        method: 'get'
    })
}

export function createTopic(data) {
    return request({
        url: '/api/v1/command/create/topic',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateTopic(data) {
    return request({
        url: '/api/v1/command/update/topic',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteTopic(id, topicUrl) {
    return request({
        url: '/api/v1/command/delete/topic/' + id + '/' + topicUrl,
        method: 'delete'
    })
}

export function addPartition(data) {
    return request({
        url: '/api/v1/command/expand/topic',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}